import { useMutation, useQueryClient } from 'react-query';
import { AxiosError } from 'axios';
import api from 'services';
import { ApiError } from 'services/api.errors';
import { IraUserRequest, IraUserResponse } from 'services/requests';
import { useQueryParams, useNavigate } from 'hooks/routes';
import { useRole } from 'hooks/common/useRole';
import { mapIraUserFields } from 'utils';
import { Parameters } from 'constants/queryParameters';
import { MutationKeys } from 'constants/mutationKeys';
import { QueryKeys } from 'constants/queryKeys';

export const useAddIraUser = () => {
  const { isAdmin } = useRole();
  const queryClient = useQueryClient();
  const { toIraUserRoleAdmin, toIraUserRoleUser } = useNavigate();
  const employerId = useQueryParams(Parameters.employerId);

  const mutate = async (payload: IraUserRequest) => {
    const { data } = await api.createIraUser(employerId, payload);
    const modifiedIraUserData = mapIraUserFields(data);
    return modifiedIraUserData;
  };

  const mutationKey = MutationKeys.addIraUser;

  return useMutation<IraUserResponse, AxiosError<ApiError>, IraUserRequest>(
    mutationKey,
    mutate,
    {
      onSuccess(data) {
        queryClient.setQueryData([QueryKeys.iraUser, data.id.toString()], data);
        queryClient.invalidateQueries(QueryKeys.iraUsers);

        if (Boolean(data.id)) {
          if (isAdmin) {
            return toIraUserRoleAdmin(employerId, data.id.toString(), { replace: true });
          }
          toIraUserRoleUser(data.id.toString(), { replace: true });
        }
      },
    },
  );
};
